import * as types from "./mutation_types";
const URL_BACKEND = process.env.VUE_APP_URL_BACKEND;
import axios from "@/lib/axioxAppli";

export const reset = ({ commit }) => {
  commit(types.USER_CREATE_RESET);
};

export const create = ({ commit }, values) => {
  commit(types.USER_CREATE_SET_ERROR, "");
  commit(types.USER_CREATE_TOGGLE_LOADING);
  axios
    .post(URL_BACKEND + "api-user/add/", values.values)
    .then((response) => {
      commit(types.USER_CREATE_SET_CREATED, true);
      commit(types.USER_CREATE_TOGGLE_LOADING);
      values.list.push(response.data);
    })
    .catch((e) => {
      commit(types.USER_CREATE_TOGGLE_LOADING);
      commit(types.USER_CREATE_SET_ERROR, e.message);
    });
};
